import React from 'react'
import { Star, HandHeart, HeartHandshake, Flame } from 'lucide-react'
import ColorPallet from '../../../../utils/ColorPallet'

function SecondSection() {
  return (
   <div className="container mx-auto px-6 pt-12 pb-14">
      {/* Our Vision */}
      <div className="pt-12">
        <h1 className="text-3xl md:text-5xl font-bold mb-14 bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text uppercase text-center">
          Visi Kami
        </h1>
         <h1 className=" sm:text-xl md:text-2xl font-bold bg-clip-text text-center whitespace-break-spaces capitalize" style={{ color: ColorPallet.primaryDarkBrown }}>
           menjadi pionir dalam industri Kecantikan rambut di Indonesia, menawarkan pengalaman transformasi diri yang tak terlupakan melalui sentuhan seni dan inovasi teknologi. Kami berkomitmen untuk menginspirasi setiap individu untuk mengekspresikan diri dengan percaya diri dan tampil memukau.
         </h1>
      </div>

      {/* Our Mission */}
      <div className=" pt-32">
         <h1 className="md:text-5xl sm:text-4xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text uppercase text-center">
          Misi Kami
         </h1>
         
         {/* Informations */}
          <div className="grid sm:grid-cols-1 md:grid-cols-4 gap-4 pt-12 mb-10 pointer-events-auto">
            {/* First Point */}
           < div className="grid grid-rows-2 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
              <HandHeart className='w-16 h-16 animate-hand-heart'/>
              <h1 className='md:text-lg font-semibold capitalize text-center'>
               Memberikan layanan tata rambut berkualitas tinggi dengan sentuhan personal.
              </h1>
            </div>
            
            {/* Second Point */}
           <div className="grid grid-rows-2 justify-center justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
             <HeartHandshake className='w-16 h-16 animate-heartbeat-shake hover:text-pink-600'/>
             <h1 className='md:text-lg font-semibold capitalize text-center'>
               Membantu pelanggan menemukan gaya rambut yang sesuai dengan kepribadian mereka.
             </h1>
           </div>

          {/* Thirth Point */}
           <div className="grid grid-rows-2 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
             <Star className='w-16 h-16 animate-rotate-360 hover:text-yellow-500'/>
              <h1 className='md:text-lg font-semibold text-center'>
               Membantu pelanggan mengekspresikan diri melalui rambut mereka.
              </h1>
           </div>
            
            {/* Fourth Point */}
           <div className="grid grid-rows-2 justify-items-center items-center border hover:border-transparent border-white rounded-lg hover:bg-gradient-to-r from-blue-600 to-purple-600 hover:text-white transform hover:scale-110 ease-in duration-300 p-6">
             <Flame className='w-16 h-16 animate-fire-flicker hover:text-orange-500'/>
              <h1 className='text-xl md:text-lg font-semibold text-center'>
               Menawarkan layanan tata rambut yang inovatif, personal, dan berkualitas tinggi.
              </h1>
           </div>
         </div>

       </div>
   </div>
  )
}

export default SecondSection